const EMPTY_VERSION = { start: '', end: '', skip: '' }
const EMPTY_APP_VERSION = { start: '', end: '', skip: '', dataSetId: '' }

function parseJson(value, fallback) {
  if (value == null || value === '') {
    return fallback
  }
  if (typeof value === 'object') {
    return value
  }
  try {
    const parsed = JSON.parse(value)
    return parsed == null ? fallback : parsed
  } catch (error) {
    return fallback
  }
}

export function emptyDesignerForm() {
  return {
    name: '',
    birthday: '',
    birthdayPublic: 0,
    type: 'User',
    introduction: '',
    homeUrl: '',
    homeUrlPublic: 0,
    country: { isExclude: true, countries: [] },
    androidApiVersion: { ...EMPTY_VERSION },
    iosApiVersion: { ...EMPTY_VERSION },
    appVersion: [{ ...EMPTY_APP_VERSION }],
    comment: '',
    backgroundUrl: '',
    backgroundName: '',
    id: '',
    categoryIds: [],
    dynamicTags: [],
    status: '',
    facebook: '',
    facebookIsPublic: 0,
    instagram: '',
    instagramIsPublic: 0,
    whatsapp: '',
    whatsappIsPublic: 0,
    telegram: '',
    telegramIsPublic: 0,
    email: '',
    emailPublic: 0,
    tagList: [],
    tags: [],
    isAuth: 0,
    authTime: '',
    authMessage: '',
    followerCount: '',
    followingCount: '',
  }
}

export function applyDesignerDetail(data) {
  const appVersion = parseJson(data.appVersion, [])
  return {
    ...emptyDesignerForm(),
    ...data,
    tags: data.tags ? String(data.tags).split(',').filter(Boolean) : [],
    backgroundUrl: data.img || '',
    comment: data.comment || '',
    categoryIds: categoryIdsFrom(data),
    dynamicTags: (data.categoryVOS || []).map((item) => item.name),
    country: parseJson(data.country, { isExclude: true, countries: [] }),
    androidApiVersion: parseJson(data.androidApiVersion, { ...EMPTY_VERSION }),
    iosApiVersion: parseJson(data.iosApiVersion, { ...EMPTY_VERSION }),
    appVersion: appVersion.length ? appVersion : [{ ...EMPTY_APP_VERSION }],
  }
}

export function buildDesignerPayload(form) {
  const appVersion = (form.appVersion || []).filter(
    (item) => item.dataSetId === '0' || item.dataSetId
  )
  return {
    ...form,
    tags: Array.isArray(form.tags) ? form.tags.join(',') : form.tags || '',
    tagList: form.categoryIds || [],
    appVersion,
  }
}

// 页面不再改关联分类；编辑保存仍带回原分类 id，避免把库里已有关联写成空。
function categoryIdsFrom(data) {
  const fromCategories = (data.categoryVOS || [])
    .map((item) => item.id)
    .filter((id) => id != null)
  if (fromCategories.length) {
    return fromCategories
  }
  if (!data.category) {
    return []
  }
  return String(data.category)
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean)
}
